import { useState } from "react";
import { useHistory } from "react-router-dom";
import { verifyLogin } from "../../api/autenticacion";
import "./Login.css";
import spinner from "./spinner4.svg";
import logo from "./logo.png";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
import { STRING_ACCESS_TOKEN_CHECKLIST, STRING_ID_EMPRESA_CHECKLIST, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_LANGUAGE, STRING_TIPO_USUARIO_CHECKLIST, STRING_VERSION } from "../../utils/const/string-const";
import { useTranslation } from "react-i18next";
import "../../utils/i18n/i18n";
import { obtenerInfoGestionarPlataforma } from "../../api/gestionar-plataforma/api-gestionar-plataforma";

export default function Login() {
  const { t, i18n } = useTranslation();
  const [usuario, setUsuario] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const submit = async (e) => {
    try {
      // console.log('submit');
      e.preventDefault();
      setLoading(true);
      const response = await verifyLogin(usuario, contrasenia);
      // console.log('response login', response);
      if (response !== null) {
        localStorage.setItem(STRING_ACCESS_TOKEN_CHECKLIST, response.token);
        localStorage.setItem(STRING_TIPO_USUARIO_CHECKLIST, response.idTipoUsuarioWeb);
        localStorage.setItem(STRING_ID_EMPRESA_CHECKLIST, response.idEmpresa);
        localStorage.setItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, response.idSubTipoUsuarioWeb);

        // await new Promise(resolve => setTimeout(resolve, 1000));
        const infoEmpresa = await obtenerInfoGestionarPlataforma();
        // console.log('infoEmpresa');
        // console.log(infoEmpresa);
        if (infoEmpresa !== null) {
          if (infoEmpresa.idioma !== null) {
            localStorage.setItem(STRING_LANGUAGE, infoEmpresa.idioma);
          }
        }
        history.push(`/dashboard`);
      } else {
        if (response === null) {
          alert(t('alert_usuario_o_contrasena_incorrecto'));
          return;
        }
        if (response !== null) {
          alert(response.message);
          return;
        }
      }
    } catch (err) {
      console.log('submit err');
      console.log(err);
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Explicitly change the language
    localStorage.setItem(STRING_LANGUAGE, lng);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <form onSubmit={submit}>
        <div className="fs f">
          <div className="login_box">
            <img id="logo" src={logo} alt="Logo Boltrack"></img>
            <span className="title">{t('label_plataforma_checklist')}</span>
            {/* Language Dropdown */}
            <div className="language-selector">
              <label htmlFor="language">{t("label_idioma")}:</label>
              <select
                id="language"
                onChange={(e) => changeLanguage(e.target.value)}
                defaultValue={i18n.language}
              >
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="pt">Portuguese</option>
              </select>
            </div>
            <br />
            <div className="login_fields">
              <div className="field_line">
                <span className="fieldname">{t("label_usuario")}:</span>
                <input
                  id="usuario_login"
                  value={usuario}
                  onChange={(e) => {
                    setUsuario(e.target.value);
                  }}
                  className="login_input"
                />
              </div>
              <div className="field_line">
                <span className="fieldname">{t("label_contrasena")}:</span>
                <div className="password_input_wrapper">
                  <input
                    id="password_login"
                    value={contrasenia}
                    onChange={(e) => {
                      setContrasenia(e.target.value);
                    }}
                    className="login_input"
                    type={showPassword ? "text" : "password"}
                  />
                  <button
                    type="button"
                    className={`password_toggle ${showPassword ? "password_toggle--active" : ""}`}
                    onClick={togglePasswordVisibility}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <span className="password_icon_wrapper">
                      <span className={`password_icon ${showPassword ? "password_icon--hidden" : "password_icon--visible"}`}>
                        <Eye size={18} />
                      </span>
                      <span className={`password_icon ${showPassword ? "password_icon--visible" : "password_icon--hidden"}`}>
                        <EyeOff size={18} />
                      </span>
                    </span>
                  </button>
                </div>
              </div>
              <div className="field_line">
                {loading === false &&
                  <button type="onSubmit" className="login_button">
                    {t("label_ingresar")}
                  </button>
                }
                {loading === true &&
                  <button className="login_button flex justify-center">
                    <img className="spinner" alt="spinner" src={spinner} />
                  </button>}
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <div
                  className="flex flex-col items-center "
                  onClick={() => history.push(`/sign-up`)}
                >
                  <label className="mt-2 cursor-pointer">{t("label_registrarse")}</label>
                </div>
                <div>
                  <label>Version: {STRING_VERSION}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
